import { Check, Loader2, AlertTriangle } from "lucide-react";
import { STAGES } from "@/lib/api";
import { PHASES } from "@/lib/guide";

const name = (id) => STAGES.find((s) => s.id === id)?.name;

function Step({ id, status, active, stale, onSelect }) {
  const tone = {
    approved: "bg-emerald-500 text-white border-emerald-500",
    running: "bg-blue-600/20 text-blue-300 border-blue-500",
    failed: "bg-rose-600/20 text-rose-300 border-rose-500",
    ready: "bg-amber-500/15 text-amber-300 border-amber-500/70",
  }[status] || "bg-transparent text-slate-500 border-slate-700";
  return (
    <button data-testid={`stage-step-${id}`} onClick={() => onSelect(id)}
      className={`group flex items-center gap-2 rounded-lg px-2 py-1.5 transition-colors ${active ? "bg-slate-800" : "hover:bg-slate-800/50"}`}>
      <span className={`h-6 w-6 shrink-0 rounded-full border grid place-items-center text-[11px] font-mono ${tone}`}>
        {status === "approved" ? <Check size={13} /> : status === "running" ? <Loader2 size={12} className="animate-spin" /> : status === "failed" ? <AlertTriangle size={11} /> : STAGES.findIndex((s) => s.id === id) + 1}
      </span>
      <span className={`text-xs whitespace-nowrap ${active ? "text-white font-semibold" : status === "approved" ? "text-slate-300" : "text-slate-400"}`}>
        {name(id)}{stale && <span className="ml-1 text-amber-400" title="Needs a re-check">•</span>}
      </span>
    </button>
  );
}

export default function StageStepper({ job, viewing, onSelect }) {
  const done = STAGES.filter((s) => job.stages[String(s.id)]?.status === "approved").length;
  const pct = Math.round((100 * done) / STAGES.length);
  return (
    <div data-testid="stage-stepper-bar">
      <div className="flex items-center gap-3 mb-3">
        <div className="text-xs text-slate-400"><span className="text-slate-100 font-semibold">{done}</span> of {STAGES.length} steps done</div>
        <div className="flex-1 h-1.5 rounded-full bg-slate-800 overflow-hidden"><div className="h-full bg-gradient-to-r from-blue-500 to-emerald-500 freq-bar" style={{ width: `${pct}%` }} /></div>
        <div className="text-xs font-mono text-slate-400">{pct}%</div>
      </div>
      <div className="flex gap-3 overflow-x-auto scroll-thin pb-1">
        {PHASES.map((p) => (
          <div key={p.name} className="shrink-0 border-l border-slate-800 pl-3 first:border-0 first:pl-0">
            <div className="text-[10px] uppercase tracking-wider text-slate-500 mb-1 px-2">{p.name}</div>
            <div className="flex gap-0.5">
              {p.stages.map((id) => (
                <Step key={id} id={id} status={job.stages[String(id)]?.status} stale={job.stages[String(id)]?.stale} active={viewing === id} onSelect={onSelect} />
              ))}
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}
